import type { GeocodeHit } from "../../api";
import { Btn, Card, I } from "../../ui";

interface AddressSearchCardProps {
  query: string;
  suggestions: GeocodeHit[];
  showSuggestions: boolean;
  busy: boolean;
  error: string | null;
  onQueryChange: (query: string) => void;
  onSearch: () => void;
  onPickSuggestion: (suggestion: GeocodeHit) => void;
  onShowSuggestions: () => void;
  onHideSuggestions: () => void;
}

export function AddressSearchCard({
  query,
  suggestions,
  showSuggestions,
  busy,
  error,
  onQueryChange,
  onSearch,
  onPickSuggestion,
  onShowSuggestions,
  onHideSuggestions,
}: AddressSearchCardProps) {
  return (
    <Card title="Cerca indirizzo" sub="scrivi una via oppure clicca sulla mappa">
      <div style={{ position: "relative" }}>
        <div className="row gap-8">
          <input
            className="input"
            placeholder="es. Via Milano 12, Roma"
            value={query}
            onChange={(e) => onQueryChange(e.target.value)}
            onFocus={() => {
              if (suggestions.length > 0) onShowSuggestions();
            }}
            onBlur={() => setTimeout(() => onHideSuggestions(), 200)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !busy) onSearch();
            }}
            style={{ flex: 1 }}
          />
          <Btn
            variant="primary"
            icon={I.search}
            onClick={() => onSearch()}
            disabled={busy || !query.trim()}
          >
            {busy ? "…" : "Cerca"}
          </Btn>
        </div>
        {showSuggestions && suggestions.length > 0 && (
          <div
            style={{
              position: "absolute",
              top: 40,
              left: 0,
              right: 80,
              background: "var(--surface-1)",
              border: "1px solid var(--line)",
              borderRadius: 8,
              zIndex: 500,
              maxHeight: 260,
              overflowY: "auto",
              boxShadow: "var(--shadow-popup)",
            }}
          >
            {suggestions.map((suggestion, index) => (
              <div
                key={index}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onPickSuggestion(suggestion);
                }}
                style={{
                  padding: "10px 12px",
                  fontSize: 12,
                  cursor: "pointer",
                  borderBottom:
                    index < suggestions.length - 1 ? "1px solid var(--line)" : 0,
                }}
                className="sug-item"
              >
                {suggestion.display_name}
                {suggestion.address?.provinceCode && (
                  <span
                    className="mono"
                    style={{
                      marginLeft: 6,
                      fontSize: 10,
                      color: "var(--text-3)",
                    }}
                  >
                    [{suggestion.address.provinceCode}]
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
        {error && (
          <div style={{ color: "var(--danger)", fontSize: 12, marginTop: 8 }}>
            {error}
          </div>
        )}
      </div>
    </Card>
  );
}
